<template>
  <div class="product-designs-layout-view">
    <ul class="uk-margin-medium-bottom" uk-tab>
      <router-link
        :to="{ name: 'product-design-artists' }"
        active-class="uk-active"
        tag="li"
      >
        <a>{{$t('tabs.productDesignArtists')}}</a>
      </router-link>
      <router-link
        :to="{ name: 'product-design-categories' }"
        active-class="uk-active"
        tag="li"
      >
        <a>{{$t('tabs.productDesignCategories')}}</a>
      </router-link>
    </ul>

    <router-view />
  </div>
</template>

<script>
import View from '@/mixins/View';

export default {
  name: 'product-designs-view',
  mixins: [View],
  computed: {
    breadcrumbs() {
      return [
        {
          key: 'productDesigns',
          route: { name: 'product-designs' },
        },
      ];
    },
  },
  i18n: {
    messages: {
      de: {
        breadcrumbs: {
          productDesigns: 'Produktdesigns',
        },
        tabs: {
          productDesigns: 'Designs',
          productDesignArtists: 'Künstler',
          productDesignCategories: 'Kategorien',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductDesignsView.vue?9815a030